// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-star[data-v-4b19cff0]{\n  margin-right:2px;\n}\n.drag-handler[data-v-4b19cff0]{\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n.show-d[data-v-4b19cff0]{\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
